import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import StepCard from "../StepCard";
import CLMS from "../../../assets/icons/Claims.png";
import PCKUP from "../../../assets/icons/PickUp.png";
import DELVRY from "../../../assets/icons/Delivery.png";
import PHNREPAIR from "../../../assets/icons/PhoneRepair.png";

// We'll add a very lightweight tilt wrapper for each StepCard
const withSimpleTilt = (WrappedComponent) => (props) => {
  // Basic tilt effect using onMouseMove & onMouseLeave
  const ref = React.useRef(null);

  const handleMouseMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left; // X position within element.
    const y = e.clientY - rect.top; // Y position within element.
    const midX = rect.width / 2;
    const midY = rect.height / 2;
    // range: -15deg to 15deg
    const rotateY = ((x - midX) / midX) * 15;
    const rotateX = -((y - midY) / midY) * 15;
    el.style.transform = `perspective(600px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.04,1.04,1.04)`;
    el.style.transition = "transform 0.09s cubic-bezier(.2,.91,.58,1)";
    el.style.zIndex = 2;
  };

  const handleMouseLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.transform =
      "perspective(600px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)";
    el.style.transition = "transform 0.35s cubic-bezier(.16,.73,.58,1)";
    el.style.zIndex = 1;
  };

  return (
    <div
      ref={ref}
      style={{
        willChange: "transform",
        perspective: "600px",
        transition: "transform 0.2s cubic-bezier(.16,.73,.58,1)",
        borderRadius: 18,
        // Can add subtle box-shadow for physical effect
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <WrappedComponent {...props} />
    </div>
  );
};

const TiltStepCard = withSimpleTilt(StepCard);

const steps = [
  {
    step: 1,
    title: "Claim in Minutes",
    description: "Call or email us — we’ll handle the rest.",
    icon: (
      <img
        src={CLMS}
        alt="Step Icon"
        style={{
          width: 100,
          height: 100,
          textAlign: "center",
          margin: "auto",
        }}
      />
    ),
  },
  {
    step: 2,
    title: "Doorstep Pickup",
    description: "We’ll collect your device. No stress, no hassle.",
    icon: (
      <img
        src={PCKUP}
        alt="Step Icon"
        style={{ width: 100, height: 100, margin: "auto" }}
      />
    ),
  },
  {
    step: 3,
    title: "Pro Repair",
    description: "Certified experts restore your device to perfection.",
    icon: (
      <img
        src={PHNREPAIR}
        alt="Step Icon"
        style={{ width: 100, height: 100, margin: "auto" }}
      />
    ),
  },
  {
    step: 4,
    title: "Swift Return",
    description: "Your device, as good as new, delivered to you.",
    icon: (
      <img
        src={DELVRY}
        alt="Step Icon"
        style={{ width: 100, height: 100, margin: "auto" }}
      />
    ),
  },
];

const HassleFree = () => (
  <Box textAlign="center" sx={{ py: 6 }} bgcolor="#fff6f1">
    <Box align="center" mb={4}>
      <Typography variant="h4" className="main-heading-font-size">
        {/* Hassle-free and convenient claim process */}
        How It Work
      </Typography>
    </Box>
    <Grid
      container
      spacing={2}
      mt={2}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        gap: 6,
      }}
    >
      {steps.map((item, idx) => (
        <Grid item xs={12} sm={6} md={3} key={item.step}>
          <TiltStepCard
            step={item.step}
            title={item.title}
            description={item.description}
            icon={item.icon}
          />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default HassleFree;
